<template>
    <div class="container trip-hero-container">
        <div class="trip-hero">
            <!-- Moments player -->
            <div class="moments-player fadeIn wow" v-if="currentMomentStream" @click="togglePlayer">
                <!-- Sign -->
                <div class="moments-sign">
                    <span class="leaf leaf-1"></span>
                    <span class="leaf leaf-2"></span>
                    <span class="leaf leaf-3"></span>
                    <span class="leaf leaf-4"></span>
                    <span class="leaf leaf-5"></span>
                    <span class="leaf leaf-6"></span>
                    <span class="leaf leaf-7"></span>
                    <span class="leaf leaf-8"></span>
                </div>

                <!-- Video -->
                <video style="object-fit: cover" autoplay="" muted="" playsinline="" preload="auto" loop="" :poster="currentMomentStream.play_filename + '_poster.0000001.jpg'" ref="momentPlayer" id="moment-player">
                    <source :src="currentMomentStream.play_filename + '.mp4'" type="video/mp4; codecs=hevc" />
                    <source :src="currentMomentStream.play_filename + '.webm'" type="video/webm" />
                </video>

                <!-- Controls -->
                <div class="controls" v-if="player">
                    <span class="play-pause" @click="togglePlayer">
                        <i class="fa fa-play" v-if="! isPlaying"></i>
                        <i class="fa fa-pause" v-if="isPlaying"></i>
                    </span>
                </div>
            </div>

            <!-- Vertical grids -->
            <div class="fadeIn wow" :class="[ item.type === 'vertical' ? 'vertical-grid' : null, item.type === 'single' ? 'single' : null, 'grid-' + (itemIndex + 1)]" :data-wow-delay="(itemIndex * 0.2) + 's'" v-for="(item, itemIndex) in layout">
                <div v-for="cell in item.cells">
                    <!-- XL -->
                    <img :src="images[cell.index].url + '?width=380&height=215'" :srcset="images[cell.index].url + '?width=380&height=215 1x, ' + images[cell.index].url + '?width=760&height=430 2x'" class="img-fluid d-none d-xl-block" @click="$root.$refs.tripPhotoSlideshow.showPhoto(images[cell.index].id)" />

                    <!-- LG -->
                    <img :src="images[cell.index].url + '?width=290&height=215'" :srcset="images[cell.index].url + '?width=290&height=215 1x, ' + images[cell.index].url + '?width=580&height=430 2x'" class="img-fluid d-none d-lg-block d-xl-none" @click="$root.$refs.tripPhotoSlideshow.showPhoto(images[cell.index].id)" />

                    <!-- MD -->
                    <img :src="images[cell.index].url + '?width=170&height=215'" :srcset="images[cell.index].url + '?width=170&height=215 1x, ' + images[cell.index].url + '?width=340&height=430 2x'" class="img-fluid d-none d-md-block d-lg-none" @click="$root.$refs.tripPhotoSlideshow.showPhoto(images[cell.index].id)" />

                    <!-- SM -->
                    <img :src="images[cell.index].url + '?width=170&height=215'" :srcset="images[cell.index].url + '?width=170&height=215 1x, ' + images[cell.index].url + '?width=340&height=430 2x'" class="img-fluid d-none d-sm-block d-md-none" @click="$root.$refs.tripPhotoSlideshow.showPhoto(images[cell.index].id)" />
                </div>
            </div>

            <!-- Show photos -->
            <button type="button" class="btn btn-light show-photos" @click="$root.$refs.tripPhotoSlideshow.showPhoto(images[0].id);">
                Fotos ansehen
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['media', 'momentStreams'],
        data() {
            return {
                currentMomentStream: null,
                currentTime: null,
                isPlaying: false,
                player: null,
            }
        },
        mounted() {
            var self = this

            // Set current moment
            if (! this.currentMomentStream && this.momentStreams && this.momentStreams.length > 0) {
                this.currentMomentStream = this.momentStreams[0]
            }
        },
        computed: {
            layout() {
                // Check if there are moment streams
                if (this.currentMomentStream) {
                    return [{
                        type: 'vertical',
                        cells: [{
                            index: 0,
                        }, {
                            index: 1,
                        }]
                    },
                    {
                        type: 'vertical',
                        cells: [{
                            index: 2,
                        }, {
                            index: 3,
                            more: true,
                        }]
                    }]
                } else {
                    return [{
                        type: 'single',
                        cells: [{
                            index: 0,
                        }]
                    },
                    {
                        type: 'vertical',
                        cells: [{
                            index: 1,
                        }, {
                            index: 2,
                        }]
                    },
                    {
                        type: 'vertical',
                        cells: [{
                            index: 3,
                        }, {
                            index: 4,
                            more: true,
                        }]
                    }]
                }
            },
            images() {
                return this.media
            },
        },
        methods: {
            togglePlayer() {
                if (this.$refs.momentPlayer.paused == true) {
                    this.$refs.momentPlayer.play()
                } else {
                    this.$refs.momentPlayer.pause()
                }
            }
        },
        watch: {
            currentMomentStream: {
                handler(val) {
                    var self = this
                    setTimeout(() => {
                        self.player = document.getElementById('moment-player')
                    }, 200)
                },
                deep: true
            },
            player: {
                handler(val) {
                    // Set listener
                    this.player.ontimeupdate = () => {
                        this.currentTime = this.player.currentTime
                    }
                    this.player.onpause = () => {
                        this.isPlaying = false
                    }
                    this.player.onplay = () => {
                        this.isPlaying = true
                    }
                },
                deep: true
            },
        }
    }
</script>
